import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as boosterDataActions from '../actions/booster-data.action';
import {LoadBoosterAutoOptimize, LoadBoosterOptimizeStatus} from '../actions/booster-data.action';
import {first, map, switchMap} from 'rxjs/operators';
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {BoosterService} from "../../websites/website/booster/services/booster.service";
import {DbResponse} from "../../shared/interceptors/db-response";
import {LoadBoosterData} from "../actions";
import {TypeUtils} from "../../shared/utils/type-utils";

@Injectable()
export class BoosterDataEffect {

  loadAutoOptimize = createEffect(() => this._actions$.pipe(
    ofType(boosterDataActions.LOAD_BOOSTER_AUTO_OPTIMIZE),
    switchMap((action: LoadBoosterAutoOptimize) => {
      return this._boosterService.optimizerSettingsGet(action.payload.websiteId)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new boosterDataActions.LoadBoosterAutoOptimizeSuccess(
                {
                  websiteId: action.payload.websiteId,
                  autoOptimizeEnabled: !!response.data.enable_auto_optimization
                });

            }
            return new boosterDataActions.LoadBoosterAutoOptimizeFail({websiteId: action.payload.websiteId});
          })
        );
    })
  ));
  loadOptimizeStatus = createEffect(() => this._actions$.pipe(
    ofType(boosterDataActions.LOAD_BOOSTER_OPTIMIZE_STATUS),
    switchMap((action: LoadBoosterOptimizeStatus) => {
      return this._boosterService.getOptimizeStatus(action.payload.websiteId, action.payload.pageUrl)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new boosterDataActions.LoadBoosterOptimizeStatusSuccess(
                {
                  websiteId: action.payload.websiteId,
                  optimizeStatus: response.data
                });

            }
            return new boosterDataActions.LoadBoosterOptimizeStatusFail({websiteId: action.payload.websiteId});
          })
        );
    })
  ));
  loadOptimizationData = createEffect(() => this._actions$.pipe(
    ofType(boosterDataActions.LOAD_BOOSTER_DATA),
    switchMap((action: LoadBoosterData) => {
      return this._boosterService.getOptimizationData(action.payload.websiteId)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              let pages,
                customPages,
                pagesCount,
                testMode,
                modeLevel,
                pageCacheStatus,
                incompatibleActivePlugins,
                webpStatus,
                pluginUpdateAvailable,
                currentVersion;
              pagesCount = response.data.global_data && response.data.global_data.data && response.data.global_data.data.page_count ? (response.data.global_data.data.term_count ? (parseInt(response.data.global_data.data.page_count, 10) + parseInt(response.data.global_data.data.term_count, 10)) : parseInt(response.data.global_data.data.page_count, 10)) : 0;
              pages = response.data.get_pages && response.data.get_pages.free && response.data.get_pages.free.data && response.data.get_pages.free.data.pages ? response.data.get_pages.free.data.pages : [];
              customPages = response.data.get_pages && response.data.get_pages.paid && response.data.get_pages.paid.data && response.data.get_pages.paid.data.pages ? response.data.get_pages.paid.data.pages : [];
              testMode = response.data.global_data && response.data.global_data.data && response.data.global_data.data.test_mode ? response.data.global_data.data.test_mode : null;
              modeLevel = response.data.get_modes && response.data.get_modes.mode ? response.data.get_modes.mode : 'extreme';
              pageCacheStatus = response.data.get_page_cache_status && response.data.get_page_cache_status ? response.data.get_page_cache_status : null;
              incompatibleActivePlugins = response.data.get_incompatible_active_plugins && response.data.get_incompatible_active_plugins.two_incompatible_plugins ? response.data.get_incompatible_active_plugins.two_incompatible_plugins : null;
              webpStatus = response.data.get_webp_status && response.data.get_webp_status.data ? response.data.get_webp_status.data : null;
              pluginUpdateAvailable = response.data.global_data && response.data.global_data.data && TypeUtils.isDefined(response.data.global_data.data.update_available) ? !!response.data.global_data.data.update_available : null;
              currentVersion = response.data.global_data && response.data.global_data.data && TypeUtils.isDefined(response.data.global_data.data.version) ? response.data.global_data.data.version : null;
              return new boosterDataActions.LoadBoosterDataSuccess(
                {
                  websiteId: action.payload.websiteId,
                  pages: pages,
                  customPages: customPages,
                  pagesCount: pagesCount,
                  testMode: testMode,
                  modeLevel: modeLevel,
                  pageCacheStatus: pageCacheStatus,
                  incompatibleActivePlugins: incompatibleActivePlugins,
                  webpStatus: webpStatus,
                  pluginInfo: [pluginUpdateAvailable, currentVersion]
                });
            }
            return new boosterDataActions.LoadBoosterDataFail({websiteId: action.payload.websiteId});
          })
        );
    })
  ));

  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _boosterService: BoosterService,
  ) {
  }
}
